import type {PageRouteConfig} from '@router';

import ExtraDeliveryPaymentSuccess from 'modules/Services/PromotionCenter/ExtraDelivery/PaymentSuccess/ExtraDeliveryPaymentSuccess';

export function createPromotionCenterExtraDeliveryPaymentSuccessRoute(): PageRouteConfig {
  return {
    element: <ExtraDeliveryPaymentSuccess />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
